// Generated from the API's TenantDbContext entity types by apps/api/Tests/Architecture/WireTypesTests.cs. Do not edit.
// Regenerate: WIRE_TYPES_REGEN=1 dotnet test apps/api/Tests/HooverCanvassingApi.Tests.csproj --filter FullyQualifiedName~WireTypesTests

export const EntityTags = [
  'AssistantAccessEntry',
  'AssistantEvent',
  'AssistantMessage',
  'AssistantMessageFeedback',
  'AssistantNote',
  'AssistantPreference',
  'AssistantProposal',
  'AssistantPush',
  'AssistantPushDevice',
  'AssistantRun',
  'AssistantRunMetrics',
  'AssistantRunRead',
  'AssistantSummary',
  'AssistantThread',
  'AssistantWakeup',
  'BankAccount',
  'BankConnection',
  'BankLineCategoryGuess',
  'BankLinePayeeIdentification',
  'BankSourceProfile',
  'BankTransaction',
  'BlockedContributionAttempt',
  'CalendarConnection',
  'CalendarEventCache',
  'CalendarSyncConflict',
  'CalendarSyncPreference',
  'CalendarWebhookSubscription',
  'CallAttempt',
  'CallSession',
  'CallSessionMove',
  'CallSheet',
  'CallSheetRow',
  'CampaignCalendarSettings',
  'CampaignFinanceSettings',
  'CampaignMessagingProfile',
  'CampaignQuestion',
  'CampaignRace',
  'CampaignTask',
  'CampaignUser',
  'CampaignUserCapability',
  'CapabilityAuditLog',
  'CapturedReceipt',
  'ChargeQuestion',
  'ClassificationHintOutcome',
  'Commitment',
  'CommitmentCheckIn',
  'ComplianceReport',
  'ConsultantPlaybook',
  'Contact',
  'ContactAnswer',
  'ContactLead',
  'Contribution',
  'ContributionAttachment',
  'ContributionRefund',
  'DailyReportWindowNotification',
  'Debt',
  'DetectorFingerprint',
  'DismissedFlag',
  'DonorInfoRequest',
  'DuplicateContactFlag',
  'ElecContributorMapEntry',
  'ElectionOutcome',
  'Expenditure',
  'ExpenditureAttachment',
  'ExportBatch',
  'ExportBatchMember',
  'FilingDeadline',
  'FilingEmailSend',
  'FilingObligation',
  'FinanceAnalyticsEvent',
  'FinanceAuditLog',
  'FinanceContact',
  'FollowUp',
  'FundraisingSettings',
  'GeocodedAddress',
  'IdentityRole',
  'IdentityRoleClaim',
  'IdentityUserClaim',
  'IdentityUserLogin',
  'IdentityUserRole',
  'IdentityUserToken',
  'ImportBatch',
  'ImportJob',
  'ImportJobRecord',
  'InvitationToken',
  'JurisdictionReportingSchedule',
  'LegalDocumentVersion',
  'LegalPublishNotification',
  'Loan',
  'LoanGuarantor',
  'Match',
  'MatchVerdict',
  'MdEmittedRow',
  'OnboardingAssistanceRequest',
  'PaymentProcessor',
  'PendingVolunteer',
  'PortalEntryRun',
  'PortalFollowUp',
  'PriorFilingAttestation',
  'ProcessorFeeStepAside',
  'Prospect',
  'ProspectList',
  'ProspectListMembership',
  'RapidReportNotification',
  'RecurringDonation',
  'ResourceLink',
  'SavedVoteGoal',
  'Shift',
  'ShiftCalendarLink',
  'ShiftLocationOverride',
  'StripeConnectAccount',
  'StripeConnectWebhookEvent',
  'SubmissionFile',
  'SubmissionPackage',
  'SubmissionPackageAttestation',
  'SubmissionPackageContribution',
  'SubmissionPackageCycleRow',
  'SubmissionPackageDebt',
  'SubmissionPackageExpenditure',
  'SubmissionPackageLoan',
  'SubmissionPackageRefund',
  'TaskCalendarLink',
  'TaskCategory',
  'TaskCategoryAccess',
  'Team',
  'TeamMembership',
  'TenantCampaign',
  'TextSendDetails',
  'TransactionFlag',
  'UserCampaignCalendarVisibility',
  'UserLegalAcceptance',
  'Vendor',
  'VoiceRecording',
  'VoiceRecordingContact',
  'Volunteer',
  'VolunteerLocation',
  'VolunteerResource',
  'Voter',
  'VoterDataDetails',
  'VoterFileElection',
  'VoterTag',
  'VoterTagAssignment',
  'VoterVote',
  'WaitlistSignup',
  'Walkbook',
  'WalkbookAssignment',
  'WalkbookHouse',
  'WorkOrder',
] as const;
export type EntityTag = (typeof EntityTags)[number];
